import { BASE_DOMAIN, baseHost, isUnderBaseDomain } from "./brandHost";

export const getBaseUrl = () => {
  const { hostname } = window.location;

  // Whenever the CRA dev server is running (npm start) — whether opened on
  // localhost OR via the machine's LAN IP from a phone/tablet — route through
  // the same-origin dev proxy (src/setupProxy.js). process.env.NODE_ENV is
  // 'development' under `npm start` and 'production' in the built bundle, so
  // production deployments are unaffected and keep hitting api.lmscampus.com.
  if (
    process.env.NODE_ENV === "development" ||
    hostname === "localhost" ||
    hostname.endsWith(".localhost")
  ) {
    // Relative path → goes through the CRA dev-server proxy. Same-origin keeps
    // SCORM SCOs working and avoids cross-origin CORS entirely in dev.
    return "/api";
  }

  // Explicit API base (enterprise on-prem). When the client serves the FE and BE
  // on different origins, set REACT_APP_API_URL=https://api.their-domain.com/api
  // at build time. Highest-priority production target. (For same-origin on-prem,
  // prefer REACT_APP_SAME_ORIGIN=true below instead.)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Production same-origin opt-in.
  // When the FE host has an nginx (or equivalent) reverse-proxy rule that
  // forwards /api/* to the vc-admin BE, set REACT_APP_SAME_ORIGIN=true at
  // build time. The FE will then send requests to its own origin, which
  // unblocks the SCORM same-origin guarantee end-to-end (Phase 1.6b).
  // Defaults to false so existing deployments without the nginx rule keep
  // hitting api.lmscampus.com exactly as before.
  //
  // Example nginx rule on the FE host:
  //   location /api/ {
  //     proxy_pass         http://vc-admin-internal:5300;
  //     proxy_http_version 1.1;
  //     proxy_set_header   Host              $host;
  //     proxy_set_header   X-Forwarded-For   $proxy_add_x_forwarded_for;
  //     proxy_set_header   X-Forwarded-Proto $scheme;
  //     proxy_set_header   X-Real-IP         $remote_addr;
  //     proxy_read_timeout 600s;
  //   }
  if (process.env.REACT_APP_SAME_ORIGIN === 'true') {
    return "/api";
  }

  // Default SaaS API — all subdomains and custom domains hit the same API
  // Custom domains (e.g. lms.abcinstitute.com) also route to api.lmscampus.com
  // because CNAME resolves to lmscampus.com infra. The Origin header carries
  // the custom domain for tenant resolution on the backend.
  return `https://api.${BASE_DOMAIN}/api`;
};

/**
 * Detect whether the current hostname represents an institute portal
 * (subdomain like abc.lmscampus.com OR custom domain like lms.abc.com)
 * vs the main platform (lms.lmscampus.com) or localhost.
 */
export const isInstitutePortal = () => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname.endsWith(".localhost")) return false;

  // lmscampus.com subdomains
  if (hostname !== BASE_DOMAIN && isUnderBaseDomain(hostname)) {
    const mainHosts = ["", "www", "lms", "app", "api"].map(baseHost);
    return !mainHosts.includes(hostname);
  }

  // Any other domain with a dot = custom domain (lms.abcinstitute.com)
  if (hostname.includes(".")) return true;

  return false;
};